module.exports = __webpack_public_path__ + "img/top_hk2.a88fa7f7.png";